document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a").forEach(function (link) {
    // URLに "https://das.ki/" を含むリンクを新しいウィンドウで開く
    if (link.href.includes("https://das.ki/")) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        window.open(link.href, "_blank");
      });
    }
  });
});